/**
 * Base class for verified-fetch plugins. This class provides a basic implementation of the `FetchHandlerPlugin`
 * interface.
 *
 * Subclasses should implement the `canHandle` and `handle` methods, and may override the `codes` and `log` properties.
 *
 * If your plugin adds/edits the context supplied in `handle`, you should increment the `context.modified` property.
 */
export class BasePlugin {
    codes = [];
    log;
    pluginOptions;
    constructor(options) {
        // convert a CamelCase string to a kebab-case string for the logger name of subclasses
        const loggerName = this.constructor.name.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
        this.log = options.logger.forComponent(loggerName);
        this.pluginOptions = options;
    }
    canHandle(context) {
        throw new Error('Not implemented');
    }
    async handle(context) {
        throw new Error('Not implemented');
    }
}
//# sourceMappingURL=plugin-base.js.map